import React from 'react';
import backgroundImage from '../background.webp';
import cardbackground from '../cardbackground.webp'; // Import card background image
import buttonImage from '../buttonimage.webp'; // Add this import
import { supabase } from '../supabaseClient';

export default function Witness({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'healingFormulasPage/witness',
                    animated_helper: 'no', // always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };

    const cardStyle = {
        width: '100%',
        maxWidth: '600px',
        height: 'auto',
        backgroundImage: `url(${cardbackground})`, // Use imported card background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        border: '2px solid black',
        borderRadius: '10px',
        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
        marginBottom: '20px', // Add space between cards
        padding: '20px',
        boxSizing: 'border-box',
    };

    const textStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
        lineHeight: '1.5',
        marginBottom: '16px',
    };

    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px',
            }}
        >
            <h2
                style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '36px',
                    fontWeight: 'bold',
                    color: '#4B5563',
                    textAlign: 'center',
                    marginTop: '16px',
                }}
            >
                Witness
            </h2>
            <div style={cardStyle}>
                <p style={textStyle}>
                    There are some times in the self-reflection process where I found it very helpful to be witnessed. This is not the same as being validated by another exactly, but it can be the same. There were times when the valuable perspective that another trusted person had to offer me was important for my growth.
                </p>
                <p style={textStyle}>
                    I can still remember being in counseling in my mid-twenties and having my counselor tell me that I had been treated unfairly by a family member. I remember it still because it woke me up. I had not even realized that what I was dealing with was unfair to me. For me, it had just been the way it was. To learn that another person saw a different view helped me start to heal from the unjust situation.
                </p>
                <p style={textStyle}>
                    Other times it is just the Presence of someone who is holding space for me as I process my experience that has been vital to the process of moving through that energy. Sometimes it is about just bringing something out to the light of day so that it can't hide and fester and cause us worry or shame anymore. When we are seen fully and loved anyway, we heal. Presence is Love.
                </p>
                <p style={textStyle}>
                    When you are guided to work with someone else in order to be witnessed, it might be the experience you need. Even when I did not have a witness, sometimes a vlog or a journal entry would allow me to witness myself. There is something about hearing yourself say what you are thinking that can give a different perspective. Sometimes when I write things down, they start to look different. The energy moves.
                </p>
            </div>
            <div style={cardStyle}>
                <p style={textStyle}>
                    If you are in a position to offer witness to another it is quite an honor. The more time you have spent being present for yourself, the easier it will be to offer your presence to others.
                </p>
                <p style={textStyle}>
                    Presence is all that is required of a witness. If you know that someone is asking for your perspective on what they have shared, it is important to validate them before offering a differing or expanded view.
                </p>
            </div>
            <div style={cardStyle}>
                <p style={textStyle}>
                    Sample text for the last card on the page. You can add your own content here as needed for the Witness page.
                </p>
            </div>
            <div style={cardStyle}>
                <img
                    src="/images/intentiontounderstandmeme.webp"
                    alt="Intention to Understand Meme"
                    style={{
                        width: '100%',
                        maxWidth: '360px',
                        height: 'auto',
                        marginBottom: '12px',
                        borderRadius: '8px',
                        border: '1px solid #4B5563',
                        objectFit: 'contain',
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}
                />
            </div>
            <div
                className="witness-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginBottom: '16px',
                    marginTop: '0',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        color: 'white',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        color: 'white',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={goHome}
                >
                    Home
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        color: 'white',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={handleSaveProgress}
                >
                    Save
                </button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .witness-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}
